module.exports = __webpack_public_path__ + "static/img/game-KOF15_phone.de0ca86.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/game/game-KOF15_phone.jpg
// module id = Q1Xt
// module chunks = 0